<template>
  <!-- 用冷分析lengOverview -->
  <span>
    <selected @childEvent="childEvent"></selected>
    <div ref="print " class="home" style="background: rgb(236, 238, 242);">
      <!-- 卡片 -->
      <el-row :gutter="13" class="ceng">
        <el-col :xs="24" :sm="16" :lg="8" :xl='8' class="card_box">
          <div class="card-panel" style="background:#8C79AC;">
            <div class="card-panel-icon-wrapper">
              <!-- <div class="el-icon-location"></div> -->
              <img src="../../../assets/Overview/icon-20.png" alt="" />
              <p>综合能耗</p>
            </div>
            <div class="p_all" style="border-left: 1px solid #b2a1cf;">
              <p style="font-size: 26px;font-weight: 200;">{{
                timerType=='DAY'?'4775.25':timerType=='MONTH'?'222264.93':'23299.71' }}tce</p>
            </div>
            <img class="p" src="../../../assets/Overview/icon-20n.png" alt="" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="8" :lg="6" :xl='6' class="card_box">
          <div class="card-panel" style="background: #E35C59;border: 2px solid #D74C49;">
            <div class="card-panel-icon-wrapper">
              <img src="../../../assets/Overview/icon-21.png" alt="" />
              <p>人均能耗</p>
            </div>
            <div class="p_all">
              <p style="font-size: 26px;font-weight: 200;">{{
                timerType=='DAY'?'444.61':timerType=='MONTH'?'145255.15':'7612.24' }}tce</p>
            </div>
            <img class="p" src="../../../assets/Overview/icon-21n.png" alt="" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="5" :xl='5' class="card_box">
          <div class="card-panel" style="background: #43B7AE;border: 2px solid #2CA59C;">
            <div class="card-panel-icon-wrapper">
              <img src="../../../assets/electric/icon-34.png" alt="" />
              <p>面积能耗</p>
            </div>
            <div class="p_all">
              <p style="font-size: 26px;font-weight: 200;">{{
                timerType=='DAY'?'144.11':timerType=='MONTH'?'44776.99':'2389.23' }}m³</p>
            </div>
            <img class="p" src="../../../assets/electric/icon-34n.png" alt="" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="5" :xl='5' class="card_box">
          <div class="card-panel" style="background: #F59447;border: 2px solid #DF833B;">
            <div class="card-panel-icon-wrapper">
              <img src="../../../assets/electric/icon-35.png" alt="" />
              <p style="white-space: nowrap;">供冷量</p>
            </div>
            <div class="p_all">
              <p style="font-size: 26px;font-weight: 200;">{{
                timerType=='DAY'?'536.97':timerType=='MONTH'?'4130.07':'3334.18' }}co2</p>
            </div>
            <img class="p" src="../../../assets/electric/icon-35n.png" alt="" />
          </div>
        </el-col>
      </el-row>


      <!-- 第二层 -->
      <el-row :gutter="13" class="ceng">
        <!-- 基本信息 -->
        <el-col :xs="24" :sm="12" :lg="8" :xl='8'>
          <span class="jianchu">
            <div class="title1">{{BuildingInfo.name || '-'}}</div>
            <el-row :gutter="12">
              <el-col :span="8">
                <div class="msgBox">
                  <div class="num"><span>{{BuildingInfo.inlineQuantity || '-'}}</span></div>
                  <div class="txt">进线数量</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="msgBox">
                  <div class="num"><span>{{BuildingInfo.transformerQuantity || '-'}}</span></div>
                  <div class="txt">变压器数量</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="msgBox">
                  <div class="num"><span>{{BuildingInfo.monitorPoints || '-'}}</span></div>
                  <div class="txt">监测点数</div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="12" style="margin-top:20px;">
              <el-col :span="8">
                <div class="msgBox">
                  <div class="num"><span>{{BuildingInfo.burdenCapacity || '-'}}</span></div>
                  <div class="txt">负荷容量</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="msgBox">
                  <div class="num"><span>{{BuildingInfo.totalCapacityKVA || '-'}}KVA</span></div>
                  <div class="txt">总容量</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="msgBox" @click="dialogVisible=true">
                  <div class="more">更多</div>
                </div>
              </el-col>
            </el-row>
          </span>
        </el-col>

        <!-- echart图 -->
        <el-col :xs="24" :sm="12" :lg="16" :xl='16'>
          <div class="echart">
            <div class="title1">能源分析</div>
            <div class="em">
              最大值 <span class="num">{{maxnum}}KWH</span>
              <div class="time">{{dated}}</div>
            </div>
            <div id="chart_example" style="height:240px;"></div>
          </div>
        </el-col>
      </el-row>

      <!-- 第三层 -->
      <el-row :gutter="13" class="ceng">
        <el-col :xs="24" :sm="12" :lg="8" :xl='8'>
          <!-- 用能占比 -->
          <div class="proportion">
            <div class="title1">分项用冷占比</div>
            <div id="proportion" style="width:98%"></div>
            <div class="boxed">


            </div>

          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="16" :xl='16'>
          <div class="r" style="flex:1;background: #fff;">
            <div class="Ranking">
              <div class="title1">用冷排行</div>
              <div id="Ranking"></div>


            </div>
          </div>
        </el-col>


      </el-row>

      <el-dialog title="更多信息" :visible.sync="dialogVisible" width="500px">
        <div class="ul" v-if="dialogVisible">
          <p>名称：{{BuildingInfo.name || '-'}}</p>
          <p style=" display: flex; align-items: center; ">建筑外观图： <el-image style="width: 50px; height: 50px"
              :src="BuildingInfo.buildingAppearancePhoto" :preview-src-list="[BuildingInfo.buildingAppearancePhoto]">
            </el-image>
          </p>
          <p>能源区域Id：{{BuildingInfo.areaId || '-'}}</p>
          <p>能源建筑类型ID：{{BuildingInfo.id || '-'}}</p>
          <p>进线来源：{{BuildingInfo.inlineSource || '-'}}</p>
          <p>进线数量：{{BuildingInfo.inlineQuantity || '-'}}</p>
          <p>变压器数量：{{BuildingInfo.transformerQuantity || '-'}}</p>
          <p>总变压器数量KVA：{{BuildingInfo.totalTransformerQuantity || '-'}}</p>
          <p>总容量KVA：{{BuildingInfo.totalCapacityKVA || '-'}}</p>
          <p>监测点数：{{BuildingInfo.monitorPoints || '-'}}</p>
          <p>电房数量：{{BuildingInfo.electricRoomQuantity || '-'}}</p>
          <p>负荷容量：{{BuildingInfo.burdenCapacity || '-'}}</p>
          <p>坐标：{{BuildingInfo.coordinate || '-'}}</p>
          <p>备注：{{BuildingInfo.memo || '-'}}</p>
          <p>年度计划用电：{{BuildingInfo.annualPlanUsePower || '-'}}</p>
          <p>年度计划用水：{{BuildingInfo.annualPlanUseWater || '-'}}</p>
          <p>年度计划用气：{{BuildingInfo.annualPlanUseGas || '-'}}</p>
          <p>区域面积：{{BuildingInfo.buildingArea || '-'}}</p>
          <p>区域面积指标：{{BuildingInfo.auildingAreaIndicator || '-'}}</p>
          <p>区域人数：{{BuildingInfo.buildingPopulation || '-'}}</p>
          <p>区域人数指标：{{BuildingInfo.buildingPopulationIndicator || '-'}}</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </span>
</template>

<script>

  //   import { EnergyUsePowerAnalyseDay, EnergyUsePowerAnalyseMonth, EnergyUsePowerAnalyseYear } from "@/utils/request";
  import * as echarts from 'echarts';
  //   import { parseTime } from "@/utils";
  import { getElectricity } from "../../../api/overView";
  import selected from '../../../components/module/temp/select_left.vue';
  import $ from 'jquery';
  var proportion, middle2, myChart;

  export default {
    components: {
      selected
    },
    //利用计算属性
    computed: {
      //   defaultTheme() {
      //     return this.$store.state.settings.style
      //   },
      //   listData() {
      //     return this.$store.state.settings.count;
      //   }
      nowBuilding() {//当前建筑
        return this.$store.cacheStore.state.setBuilding;
      }
    },

    //监听执行
    watch: {
      listData(val) {
        this.valueId = val;
        this.childEvent(this.valueIndex);
      },
      nowBuilding(val) {
        console.log("侦听器", val);

      },
    },
    filters: {
      widthed: (v, total) => {
        var d = v / total * 100;
        if (d) {
          return 'width:' + d + '%'
        } else {
          return 'width:0'
        }

      },
      shuzi: function (v) {
        if (v) {
          return v.toFixed('2')
        }
        return 0
      },
      guolv: function (v) {
        if (v) {
          return v.toFixed(4)
        } else {
          return '-'
        }
      }
    },
    data() {
      return {
        timerType: 'DAY',
        areaObj: {},
        // dated: parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}'),
        // dated: (new Date()).toLocaleString(),
        dated: (new Date()).toLocaleString(),
        valueIndex: 0,
        total: 0,//分项用电占比总数
        dialogVisible: false,
        BuildingInfo: {
          "id": "23a7bebc4b3f4a3890031d335924b504",
          "code": "34",
          "name": "T2",
          "buildingAppearancePhoto": "http://47.118.40.13:5001/images\\1121152848news.png",
          "energyBuildingTypeId": "2e6ed5a3e1ba44f1a5f09ff3a53c0fa6",
          "inlineSource": "1",
          "inlineQuantity": Math.round(Math.random() * 10),
          "transformerQuantity": Math.round(Math.random() * 10),
          "totalTransformerQuantity": Math.round(Math.random() * 10),
          "totalCapacityKVA": Math.round(Math.random() * 10),
          "monitorPoints": Math.round(Math.random() * 10),
          "electricRoomQuantity": Math.round(Math.random() * 10),
          "burdenCapacity": Math.round(Math.random() * 10),
          "coordinate": "113.58099741099552,22.2743984535281",
          "memo": "1",
          "annualPlanUsePower": Math.round(Math.random() * 10),
          "annualPlanUseWater": Math.round(Math.random() * 10),
          "annualPlanUseGas": Math.round(Math.random() * 10),
          "buildingArea": Math.round(Math.random() * 10),
          "buildingAreaIndicator": Math.round(Math.random() * 10),
          "buildingPopulation": Math.round(Math.random() * 10),
          "buildingPopulationIndicator": Math.round(Math.random() * 10)
        },
        EnergySubItemTotals: [],//分项用冷占比
        OrganizationEnergyTotals: [{ OrganizationName: "其他组织 ", EnergyTotals: [] }],
        ThisIssueData: [],
        Total: { TotalEnergyConsumption: 0, BuildingAreaEnergyConsumption: 0, BuildingPopulationEnergyConsumption: 0 },
        valueId: '',
        options: {
          tooltip: {
            trigger: "item",
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            type: 'scroll',
            top: 10,
            right: 10,
            orient: "vertical",
            icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            // itemWidth: 10, // 设置宽度
            // itemHeight: 10, // 设置高度
            type: 'scroll',
            itemGap: 20 // 设置间距
          },
          label: {
            alignTo: "edge",
            formatter: "{name|{b}}\n{time|{c}} ({d}%)",
            minMargin: 5,
            edgeDistance: 10,
            lineHeight: 15,
            rich: {
              time: {
                fontSize: 10,
                color: "#999"
              }
            }
          },

          color: ["#60acf2", "#4ecb73", "#6071f2", "#36cbcb"],
          series: [
            {
              name: "分项用能分析",
              type: "pie",
              radius: "59%",
              center: ["36%", "55%"],
              itemStyle: {
                borderColor: "#fff",
                borderWidth: 1
              },
              labelLine: {
                normal: {
                  length: 0
                }
              },
              data: [],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
        },
        options2: {
          grid: {
            top: "5% ",
            left: 52,
            right: 95,
            bottom: 26
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "line" // 'shadow' as default; can also be 'line' or 'shadow'
            }
          },


          xAxis: {
            type: "category",
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,
              textStyle: {
                color: '#000',
                fontSize: '16'
              }
            },
            axisLine: {
              show: false
            },
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            splitLine: {
              //网格线
              show: true
            }
          },
          yAxis: {
            type: "value"
          },
          color: ["#60acf2", "#6071f2"],
          series: [
            {
              name: "总能耗",
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              type: "bar",
              barGap: 0,
              emphasis: {
                focus: "series"
              },
            },

          ]
        },

        tableData: [
          {
            all: "总能耗",
            name: "231kwh",
            address: "289kwh"
          }
        ],
        columns: [
          {
            name: "部门",
            key: "name",
          },

          {
            name: "其他组织",
            key: "address",
          },
        ],
        maxnum: '',
        dayData: [],
        monthData: [],
        yearData: [],
        iconStatused: false,
        middleData: {
          legend: {
            data: [],
            bottom: 0,

            icon: "rect", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10, // 设置宽度
            itemHeight: 10, // 设置高度
            itemGap: 25 // 设置间距
          },
          grid: {
            top: "8% ",
            left: 72,
            right: 45,
            bottom: 46
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow" // 'shadow' as default; can also be 'line' or 'shadow'
            }
          },
          xAxis: {
            splitLine: {
              //网格线
              show: true
            },
            splitArea: {
              //坐标轴在 grid 区域中的分隔区域，默认不显示。
              interval: "auto",
              show: false, //是否显示分隔区域
              areaStyle: {
                color: ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"], //分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
                shadowColor: "red", //阴影颜色
                shadowOffsetX: 0, //阴影水平方向上的偏移距离。
                shadowOffsetY: 0, //阴影垂直方向上的偏移距离
                shadowBlur: 10, //图形阴影的模糊大小。
                opacity: 1 //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形
              }
            },
            type: "category",
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,
              textStyle: {
                color: '#000',
                fontSize: '16'
              }
            },
            axisLine: {
              show: false
            },
            z: 99,
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月',]
          },
          yAxis: {
            type: "value"
          },
          series: [
            {
              data: [1, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              type: "line",
              showBackground: true,
              backgroundStyle: {
                color: "rgba(180, 180, 180, 0.2)"
              }
            }
          ]
        },
        energyConsumptionVo: {},//头部四个

      };
    },


    mounted() {

      for (let i = 1; i <= 31; i++) {
        if (i <= 24) {
          this.dayData.push(i)
        }
        if (i <= 12) {
          this.yearData.push(i + '月')
        }
        this.monthData.push(i);
      }

      this.middleData.xAxis.data = this.dayData;
      // console.log("当前选中的区域",this.$store.cacheStore.state.setBuilding);
      this.areaObj = this.$store.cacheStore.state.setBuilding
      this.init();
      this.childEvent(this.valueIndex);
      this.getListDay()
    },
    methods: {
      childEvent(v) {
        this.valueIndex = v;
        if (v === 0) {
          this.timerType = 'DAY';
          this.middleData.xAxis.data = this.dayData;
          this.getList_fn(this.areaObj, 'DAY');
          var d = [{
            "Day": 5,
            "Value01": 2.0,
            "Value02": 3.0,
            "Value03": 4.0,
            "Value04": 34.0,
            "Value05": 4.0,
            "Value06": 4.0,
            "Value08": 34.0,
            "Value09": 45.0,
            "Value10": 0.0,
            "Value11": 40.0,
            "Value12": 34.0,
            "Value13": 4.0,
            "Value14": 0.0,
            "Value15": 0.0,
            "Value16": 0.0,
            "Value17": 0.0,
            "Value18": 0.0,
            "Value19": 0.0,
            "Value20": 0.0,
            "Value21": 0.0,
            "Value22": 0.0,
            "Value23": 0.0,
            "Value24": 0.0,
            "DayValue": 0.0
          }]
          this.ThisIssueData_fn(d)
        }
        if (v === 1) {
          this.timerType = 'MONTH';
          this.middleData.xAxis.data = this.monthData;
          // this.getListMonth();
          this.getList_fn(this.areaObj, 'MONTH');
          var d = [{
            "Day": 5,
            "Value01": 2.0,
            "Value02": 3.0,
            "Value03": 4.0,
            "Value04": 34.0,
            "Value05": 4.0,
            "Value06": 4.0,
            "Value08": 34.0,
            "Value09": 45.0,
            "Value10": 0.0,
            "Value11": 40.0,
            "Value12": 34.0,
            "Value13": 4.0,
            "Value14": 0.0,
            "Value15": 0.0,
            "Value16": 0.0,
            "Value17": 0.0,
            "Value18": 0.0,
            "Value19": 0.0,
            "Value20": 0.0,
            "Value21": 0.0,
            "Value22": 0.0,
            "Value23": 0.0,
            "Value24": 1.0,
            "Value25": 0.0,
            "Value26": 0.0,
            "Value27": 0.0,
            "Value28": 4.0,
            "Value29": 33.0,
            "Value30": 44.0,
            "Value31": 4.0,
            "DayValue": 0.0
          }]
          this.ThisIssueData_fn(d)
        }
        if (v === 2) {
          this.timerType = 'YEAR';
          this.middleData.xAxis.data = this.yearData;
          this.getList_fn(this.areaObj, 'YEAR');
          var d = [{
            "Day": 5,
            "Value01": 23.0,
            "Value02": 32.0,
            "Value03": 4.0,
            "Value04": 34.0,
            "Value05": 4.0,
            "Value06": 4.0,
            "Value08": 34.0,
            "Value09": 45.0,
            "Value10": 1.0,
            "Value11": 40.0,
            "Value12": 34.0,
          }]
          this.ThisIssueData_fn(d)
        }
        $('.r .Ranking').height($('.proportion').height() + 'px')
      },
      init() {
        // 能源分析图
        myChart = echarts.init(document.getElementById("chart_example"));
        console.log("饼图", this.middleData);

        myChart.setOption(this.middleData);
        myChart.resize({ height: 260 });

        //用冷排行
        middle2 = echarts.init(document.getElementById("Ranking"));
        middle2.setOption(this.options2, true);
        middle2.resize({ height: 266 });
        //分项用冷占比
        proportion = echarts.init(document.getElementById("proportion"));
        proportion.setOption(this.options, true);
        proportion.resize({ height: 215 });
        $(window).resize(function () {
          myChart.resize({ height: 260 });
          middle2.resize({ height: 266 });
          proportion.resize({ height: 215 });
        });
      },
      //获取数据
      getList_fn(item, type) {
        var d = {
          'areaId': item.id,
          'timeType': type,
          'energyType': 36,
        }
        console.log("参数", d);

      },
      getListDay() {

        // if (!d.buildingIds[0]) {
        //   return
        // }
        // EnergyUsePowerAnalyseDay(d).then(res => {
        var res = {
          "Status": 200,
          "Success": true,
          "Msg": "获取成功",
          "Response": {
            "Total": {
              "TotalEnergyConsumption": 0.0,
              "BuildingAreaEnergyConsumption": 0.0,
              "BuildingPopulationEnergyConsumption": 0.0,
              "ConvertCarbonEmissions": 0.0
            },
            "BuildingInfo": {
              "id": "23a7bebc4b3f4a3890031d335924b504",
              "Code": "34",
              "name": "T2",
              "BuildingAppearancePhoto": "http://47.118.40.13:5001/images\\1121152848news.png",
              "EnergyBuildingTypeId": "2e6ed5a3e1ba44f1a5f09ff3a53c0fa6",
              "InlineSource": "1",
              "InlineQuantity": 1,
              "TransformerQuantity": 1,
              "TotalTransformerQuantity": 1,
              "TotalCapacityKVA": 1,
              "MonitorPoints": 1,
              "ElectricRoomQuantity": 1,
              "BurdenCapacity": 1,
              "Coordinate": "113.58099741099552,22.2743984535281",
              "Memo": "1",
              "AnnualPlanUsePower": 1.0,
              "AnnualPlanUseWater": 1.0,
              "AnnualPlanUseGas": 1.0,
              "BuildingArea": 1.0,
              "BuildingAreaIndicator": 1.0,
              "BuildingPopulation": 1.0,
              "BuildingPopulationIndicator": 1.0
            },
            "ThisIssueData": [],
            "EnergySubItemTotals": [{
              "Name": "空调",
              "Value": 30044.52
            }, {
              "Name": "冰场",
              "Value": 3679.43
            }, {
              "Name": "冰箱",
              "Value": 4038.69
            }],
            "OrganizationEnergyTotals": [{
              "OrganizationName": "1栋",
              "EnergyTotals": [{
                "Name": "1栋",
                "Value": 14038.69
              },]
            }, {
              "OrganizationName": "2栋",
              "EnergyTotals": [{
                "Name": "2栋",
                "Value": 13360.58
              }]
            }, {
              "OrganizationName": "3栋",
              "EnergyTotals": [{
                "Name": "3栋",
                "Value": 11368.94
              }]
            }]
          }
        }
        if (res.Success) {

          this.EnergySubItemTotals = res.Response.EnergySubItemTotals;//饼图
          if (this.EnergySubItemTotals.length) {
            this.total = 0;

            this.options.series[0].data = [];
            this.EnergySubItemTotals.map(v => {
              if (v.Value) {
                v.Value = v.Value.toFixed(2);
                this.total += parseInt(v.Value);
              }

              this.options.series[0].data.push({
                value: v.Value,
                name: v.Name,
              });
            });
            this.total = this.total ? this.total : 0;
          }
          proportion.setOption(this.options, true);




          this.OrganizationEnergyTotals_fn(res.Response.OrganizationEnergyTotals);



          // 能源分析 
          this.Total = res.Response.Total;
        }
        // });

      },
      // 部门用电排行fn
      OrganizationEnergyTotals_fn(val) {
        if (!val.length) {
          return
        }
        this.columns = [{
          name: "部门",
          key: "Name",
        },];
        // 用冷排行 
        this.options2.series = [];
        this.options2.xAxis.data = [];
        this.tableData = [{
          Name: '总能耗'
        }];
        this.options2.series.push({
          name: '',
          data: [],
          type: "bar",
          barGap: 0,
          barWidth: 30,//柱图宽度
          emphasis: {
            focus: "series"
          },
        });
        val.map((v, i) => {
          this.options2.xAxis.data.push(v.OrganizationName);
          this.columns.push({
            name: v.OrganizationName,
            key: 'Value' + i
          })
          if (v.EnergyTotals.length) {
            v.EnergyTotals.map((e, ei) => {
              this.tableData[0].Name = '总能耗'
              this.tableData[0]['Value' + i] = parseInt(e.Value * 100) / 100
              this.options2.series[0].name = e.Name;
              this.options2.series[0].data.push(parseInt(e.Value * 100) / 100);

            })
          } else {
            this.options2.series.push({
              name: v.OrganizationName,
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              type: "bar",
              barGap: 0,
              emphasis: {
                focus: "series"
              },
            });

          }

        });
        middle2.setOption(this.options2, true);
      },
      // 能源分析
      ThisIssueData_fn(val) {
        if (!val.length) {
          return
        }
        var ii = 1;
        var b = [];
        // 能源分析   
        this.middleData.series = [];
        this.middleData.legend.data = [];
        var max = []
        this.middleData.legend.data.push('能源分析' + val[0].Day);
        this.middleData.series.push({
          name: '能源分析' + val[0].Day,
          data: [],
          type: "line",
          smooth: true,
          showBackground: true,
          backgroundStyle: {
            color: "rgba(180, 180, 180, 0.2)"
          }
        })


        for (const key in val[0]) {
          if (Object.hasOwnProperty.call(val[0], key)) {
            const element = val[0][key];
            if (key.indexOf("Value") == 0) {
              this.middleData.series[0].data.push(element ? element.toFixed(2) : element);
              max.push(element);
              b.push(ii++);
            }
          }
        }

        this.middleData.legend.data.length > 6 ? this.middleData.legend.type = 'scroll' : this.middleData.legend.type = 'plain';
        this.maxnum = Math.max(...max).toFixed(2);
        myChart.setOption(this.middleData, true);
      },
      getListMonth() {
        var d = {
          //   buildingIds: this.valueId ? [this.valueId] : [this.$store.state.settings.count],
          buildingIds: this.valueId ? [this.valueId] : [0],
          beginTime: (new Date(), '{y}-{m}-{d}'),
          endTime: (new Date(), '{y}-{m}-{d}'),
        };
        if (!d.buildingIds[0]) {
          return
        }

      },
      getListYear() {
        var d = {
          //   buildingIds: this.valueId ? [this.valueId] : [this.$store.state.settings.count],
          buildingIds: this.valueId ? [this.valueId] : [0],
          //   beginTime: parseTime(new Date(), '{y}-{m}-{d}'),
          beginTime: (new Date(), '{y}-{m}-{d}'),
          //   endTime: parseTime(new Date(), '{y}-{m}-{d}'),
          endTime: (new Date(), '{y}-{m}-{d}'),
        };
        if (!d.buildingIds[0]) {
          return
        }

      },

      getReadDeviceTree() {
        request.post("/virtualDevice/getReadDeviceTree.do").then(data => {
          if (data && data.success) {
            let d = [];
            d.push(data.data);
            d.map(v => {
              v.next.map(vv => {
                if (vv.next) {
                  vv.next.map(b => {
                    if (b.next) {
                      b.next.map(bb => {
                        if (!bb.next) {
                          bb.next = "";
                        }
                      });
                    } else {
                      b.next = "";
                    }
                  });
                } else {
                  vv.next = "";
                }
              });
            });
            localStorage.setItem("getReadDeviceTree", JSON.stringify(d));
          }
        });
        // getSvgTree
        request.post("/svg/getSvgTree.do").then(data => {
          if (data && data.success) {
            let d = [];
            d.push(data.data);
            d.map(v => {
              v.next.map(vv => {
                if (vv.next) {
                  vv.next.map(b => {
                    if (b.next) {
                      b.next.map(bb => {
                        if (!bb.next) {
                          bb.next = "";
                        }
                      });
                    } else {
                      b.next = "";
                    }
                  });
                } else {
                  vv.next = "";
                }
              });
            });
            localStorage.setItem("getSvgTree", JSON.stringify(d));
          }
        });
        //
      },
      tableRowClassName({ row, rowIndex }) {
        if (rowIndex % 2 === 0) {
          return "success-row";
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .boxed {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .progress {
      width: 45%;
      margin-bottom: 17px;
    }
  }

  .ul p {
    margin-bottom: 7px;
  }

  .r {
    margin-top: 11px;
  }

  .ceng {
    width: 101%;
  }

  .home {
    padding: 20px;
    background: #eceef2;
    padding-top: 10px;
  }

  .em_p {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: #5f5f5f;
  }

  .paginationed {
    border: 1px solid #ebeef5;
    border-top: none;
    display: flex;
    justify-content: flex-end;
    padding: 10px 0;
  }

  // 用冷排行
  .Ranking {
    background: #fff;
    overflow: hidden;
    /* height: 487px; */
    box-sizing: border-box;
    padding-left: 23px;
    padding-right: 13px;
    padding-bottom: 11px;
    margin-right: 15px;

    .title1 {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #5f5f5f;
      margin-top: 10px;
      margin-bottom: 9px;
    }
  }

  // 分项用能占比
  .proportion {
    background: #fff;
    /* height: 487px; */
    box-sizing: border-box;
    padding-left: 23px;
    padding-right: 13px;
    padding-bottom: 11px;
    overflow: hidden;
    margin-top: 11px;

    #proportion {
      margin-top: 20px;
      height: 236px;
      background: rgba(241, 203, 50, 0);
      border: 1px solid #dadada;
      margin-bottom: 40px;
    }

    .title1 {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #5f5f5f;
      margin-top: 10px;
      margin-bottom: 9px;
    }

    .progress {
      .tit {
        font-size: 13px;
        color: #636363;
        width: 137px;
        display: flex;
        justify-content: space-between;
        white-space: nowrap;

        >span {
          font-size: 14px;
          font-weight: 300;
          font-family: Microsoft YaHei;
          color: #636363;
        }
      }

      .jindu {
        width: 100%;
        height: 25px;
        border: 1px solid #dadada;
        margin-top: 6px;

        >span {
          display: block;
          height: 100%;
          box-sizing: border-box;
          padding-right: 5px;
          text-align: right;
          background: #eaeef2;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #5d5d5d;
          line-height: 25px;
        }
      }
    }
  }

  // 用电分析
  .echarted {
    flex: 1;
    background: #fff;
    height: 164px;
    box-sizing: border-box;
    padding-left: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 35px;

    .right {
      .right_pro {
        display: flex;
        flex-direction: column;
        align-items: center;

        .pt {
          font-size: 11px;
          color: #3d3d3d;
          margin-top: 9px;
        }
      }
    }

    .left {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      color: #5f5f5f;
      margin-right: 15px;

      .tit {
        letter-spacing: 3px;
        margin-right: 13px;
        writing-mode: vertical-lr;
        /*从左向右 从右向左是 writing-mode: vertical-rl;*/
        writing-mode: tb-lr;
        /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
      }

      .data {
        font-size: 11px;
        color: #6c6c6c;

        .bom:nth-child(1) {
          border-bottom: 1px solid #bcbcbc;
        }

        .bom {
          display: flex;
          flex-direction: column;
          padding: 10px 0;

          .em {
            display: flex;

            .name {
              width: 52px;
              text-align: right;
              margin-right: 10px;
            }

            .num {
              font-size: 14px;
              color: #3d3d3d;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }

  // 能耗统计
  .tongji {
    width: 39.4%;
    background: #fff;
    box-sizing: border-box;
    padding-left: 23px;
    padding-right: 13px;
    padding-bottom: 11px;
    margin-right: 15px;

    .title1 {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #5f5f5f;
      margin-top: 10px;
      margin-bottom: 5px;
    }
  }

  .tongji_box {
    border: 1px solid #ccc;

    .top {
      display: flex;
      justify-content: space-between;
      padding: 2px 10px;
      font-size: 13px;
      font-weight: bold;
      color: #3d3d3d;
    }

    .bom {
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
      color: #6c6c6c;
      background: #f4f4f4;
    }
  }

  // 能源分析
  .echart {
    background: #fff;
    height: 310px;
    box-sizing: border-box;
    position: relative;

    .title1 {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #5f5f5f;
      line-height: 47px;
      padding-left: 23px;
    }

    .em {
      display: flex;
      font-size: 12px;
      color: #636363;
      justify-content: flex-end;
      position: absolute;
      right: 44px;
      top: 27px;
      align-items: center;

      .num {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #f0822a;
        margin: 0 10px;
      }

      .time {
        font-size: 11px;
        color: #636363;
        margin-left: 16px;
      }
    }
  }

  // 基本信息
  .jianchu {
    background: #fff;
    display: block;
    padding: 0 15px 24px 15px;
    overflow: hidden;

    .title1 {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #5f5f5f;
      margin-top: 16px;
      margin-bottom: 25px;
    }

    .msgBox {
      height: 103px;
      background: #ffffff;
      border: 2px solid #d6dded;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      .more {
        flex: 1;
        line-height: 103px;
        font-size: 14px;
        color: #636363;
      }

      .num {
        flex: 1;
        font-size: 24px;
        font-weight: bold;
        color: #5496cf;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .txt {
        height: 41px;
        background: #eaeef2;
        text-align: center;
        color: #5d5d5d;
        font-size: 14px;
        line-height: 41px;
        width: 100%;
      }
    }
  }

  .p_all {
    display: flex;
    color: #fff;
    height: 100%;
    box-sizing: border-box;
    font-size: 14px;
    height: 62px;
    margin-top: 8px;
    font-size: 26px;
    padding-left: 10px;
    align-items: center;
    font-weight: 200;
  }

  .p_all p {
    margin: 0;
    font-family: "element-icons";
  }

  .panel-group {
    margin-top: 5px;
    margin-bottom: 14px;
  }

  .el-icon-top {
    color: #ff8522;
    font-weight: bold;
  }

  .el-icon-bottom {
    color: #4cb546;
    font-weight: bold;
  }

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card_box .p {
    position: absolute;
    right: 0;
    bottom: 0;
    font-size: 30px;
    color: #dbe7fd6b;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);
    height: 79px;
    background: #8c79ac;
    border: 2px solid #79669b;
    margin: 10px 0;
    margin-bottom: 10px;

    .card-panel-icon-wrapper {
      float: left;
      transition: all 0.38s ease-out;
      display: flex;
      flex-direction: column;
      color: #fff;
      height: 100%;
      width: 35%;
      justify-content: center;
      text-align: center;

      >img {
        width: 47px;
        margin: 3px auto;
      }

      >div {
        font-size: 50px;
        margin-bottom: 0;
      }

      p {
        font-size: 16px;
      }
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
</style>